import PropTypes from 'prop-types';
import React, { Component } from 'react';

import FormGenerator from 'Components/Form/FormGenerator';

const MODE = {
  EDIT: 'EDIT',
  CREATE: 'CREATE',
  BOTH: 'BOTH',
};

const getFields = (isEdit) => {
  const fields = [
    {
      inputType: FormGenerator.INPUT_TYPE.TEXT_FIELD,
      inputLabel: 'Title',
      inputName: 'title',
      inputProps: {
        required: true,
      },
      mode: MODE.BOTH,
    },
    {
      inputType: FormGenerator.INPUT_TYPE.TEXT_FIELD,
      inputLabel: 'SKUCode',
      inputName: 'SKUCode',
      inputProps: {
        required: true,
      },
      mode: MODE.BOTH,
    },
  ];
  return fields.filter(
    (f) =>
      f.mode === MODE.BOTH ||
      (isEdit && f.mode === MODE.EDIT) ||
      (!isEdit && f.mode === MODE.CREATE)
  );
};

export default class BookForm extends Component {
  static propTypes = {
    onCreateBook: PropTypes.func,
    isEdit: PropTypes.bool,
  };

  static defaultProps = {
    onCreateBook: () => {},
    isEdit: false,
  };

  handleSubmit = (form) => {
    this.props.onCreateBook(form);
  };

  render() {
    const { isEdit } = this.props;
    return (
      <FormGenerator
        fields={getFields(isEdit)}
        onSubmit={this.handleSubmit}
        submitText={isEdit ? 'Update' : 'Add'}
        cancelText="Cancel"
        showCancel
        {...this.props}
      />
    );
  }
}
